<ion-modal
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch modal-sheet'
      : 'ion-modal-desktop modal-desktop-size-md'
  "
  [initialBreakpoint]="
    platformService.platformType !== platformService.platformEnum.desktop
      ? 1
      : undefined
  "
  [breakpoints]="
    platformService.platformType !== platformService.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  [isOpen]="foodCostCalculatorService.showDeleteFoodCostReportModal | async"
  (didDismiss)="onDidDismiss()"
>
  <ng-template>
    <ion-header
      class="ion-no-border"
      [ngClass]="
        (platformService?.isTouchExperience$ | async)
          ? platformService?.platformType ===
            platformService?.platformEnum?.tablet
            ? 'ion-header-modal-tablet'
            : 'ion-header-modal-mobile'
          : 'ion-header-modal-desktop'
      "
    >
      <ion-toolbar>
        <ion-buttons
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
          slot="end"
        >
          <ion-button
            id="close-modal-btn"
            data-cy="close-delete-food-cost-report-modal-button"
            (click)="dismissModal()"
          >
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content
      data-cy="modal-delete-food-cost-report-area-text"
      [ngClass]="
        (platformService?.isTouchExperience$ | async)
          ? platformService?.platformType ===
            platformService?.platformEnum?.tablet
            ? 'ion-content-modal-tablet'
            : 'ion-content-modal-mobile'
          : 'ion-content-modal-desktop'
      "
    >
      <div class="content">
        <img
          class="alert-icon-border"
          src="../../../../../../assets/images/alert-yellow.svg"
        />

        <div>
          <h3 data-cy="delete-food-cost-report-label">
            {{
              'i18n.inventory.foodCost.deleteReportMessage' | translate
            }}&nbsp;
          </h3>
          <h3
            class="report-dates"
            data-cy="delete-food-cost-report-label-dates"
          >
            {{ foodCostReport?.startPeriod | date: 'M/d/yyyy' }}&nbsp;-&nbsp;{{
              foodCostReport?.endPeriod | date: 'M/d/yyyy'
            }}?
          </h3>
        </div>
      </div>
    </ion-content>

    <ion-footer
      class="ion-footer-modal"
      [class.ion-footer-modal-desktop]="
        (platformService?.isTouchExperience$ | async) === false
      "
    >
      <ion-toolbar>
        <ion-buttons>
          <ion-button
            id="no-modal-btn"
            data-cy="cancel-delete-food-cost-report-modal-button"
            [ngClass]="
              platformService?.platformType !==
              platformService?.platformEnum?.mobile
                ? 'usf-outline-green-dsktp-tblt-modal-button'
                : 'usf-outline-green-mobile-modal-button'
            "
            (click)="dismissModal()"
          >
            {{ 'i18n.common.cancel' | translate }}
          </ion-button>
          <ion-button
            id="yes-modal-btn"
            data-cy="confirm-delete-food-cost-report-modal-button"
            [ngClass]="
              platformService?.platformType !==
              platformService?.platformEnum?.mobile
                ? 'usf-fill-green-dsktp-tblt-modal-button'
                : 'usf-fill-green-mobile-modal-button'
            "
            (click)="onDeleteFoodCostReport()"
          >
            {{ 'i18n.common.delete' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
